$shm_hitalama_map_fontsize $mol_view
	sub /
		<= Search $mol_search
			hint @ \Font size
			query? <=> font_size_selected? \
			anchor_content /
				<= Font_size $mol_number
					minimal_width 64
					value? <=> font_size? 16
					Dec null
					Inc null
			suggests <= font_size_suggests /string
		<= Inc_dec $mol_view
			sub /
				<= Inc $mol_button_minor
					hint @ \Increase font size
					minimal_height 20
					minimal_width 20
					event_click? <=> font_size_inc? null
					sub / <= inc_icon $mol_icon_chevron_up
				<= Dec $mol_button_minor
					hint @ \Decrease font size
					minimal_height 20
					minimal_width 20
					event_click? <=> font_size_dec? null
					sub / <= dec_icon $mol_icon_chevron_down
	font_size_options /number
		10
		12
		14
		16
		18
		24
		36
		48
		64
		80
		144
		288
